import { Button, Card, Flex, Text, Tooltip } from '@mantine/core';
import { defaultTheme } from '@dealstack/frontend/shared/mechanism/styleguide/defaultTheme';
import { PersonStatus } from '@dealstack/frontend/shared/components/ExpandablePersonCard/ExpandablePersonCard.types';
import { SignerStatusPill } from '@dealstack/frontend/shared/components/ExpandablePersonCard/SignerStatusPill';
import { PersonCardMenu } from '@dealstack/frontend/shared/components/ExpandablePersonCard/PersonCardMenu';
import type { GroupMenuItem } from '@dealstack/frontend/shared/components/ExpandablePersonCard/GroupHeader.types';

interface Props {
	label: string;
	subtitle?: string;
	status?: PersonStatus;
	action?: {
		label: string;
		onClick: () => void;
		loading?: boolean;
	};
	menuItems?: GroupMenuItem[];
	menuTestId?: string;
}

export const SubPersonRow = ({ label, subtitle, status, action, menuItems, menuTestId }: Props) => {
	return (
		<Card
			p="0.5rem"
			style={{
				border: `1px solid ${defaultTheme.v3.colors.gray[4]}`,
				borderRadius: '0.25rem',
			}}
		>
			<Flex direction="column" gap="0.125rem">
				<Flex gap="0.5rem" align="center">
					<Tooltip label={label} openDelay={100} withinPortal>
						<Text
							size="0.8125rem"
							c="dark.0"
							lh="1.25rem"
							truncate="end"
							style={{ flex: 1, minWidth: 0 }}
						>
							{label}
						</Text>
					</Tooltip>
					{status && <SignerStatusPill status={status} />}
					{menuItems && menuItems.length > 0 && (
						<PersonCardMenu menuItems={menuItems} menuTestId={menuTestId} />
					)}
				</Flex>
				{subtitle && (
					<Text size="0.75rem" c="blue.6" fw={500} lh="1rem">
						{subtitle}
					</Text>
				)}
				{action && (
					<Button
						size="xs"
						mt="0.5rem"
						w="fit-content"
						onClick={action.onClick}
						loading={action.loading}
					>
						{action.label}
					</Button>
				)}
			</Flex>
		</Card>
	);
};
